import { useState } from 'react';
import { useInView } from '@/hooks/useInView';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [ref, inView] = useInView(0.1);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注！');
      return;
    }

    if (!email.trim()) return;

    setStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      await fetch('https://readdy.ai/api/form/d917a946ci2plld1ojsg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      setStatus('success');
      setMessage('订阅成功！感谢你的关注，新鲜大瓜第一时间送到你手中！');
      setEmail('');
    } catch {
      setStatus('error');
      setMessage('订阅失败，请稍后再试。');
    }
  };

  return (
    <section ref={ref} className={`py-14 md:py-20 px-4 md:px-6 bg-background-100 transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <div className="max-w-3xl mx-auto text-center">
        <div className="rounded-2xl overflow-hidden mb-10 md:mb-14">
          <img
            src="https://readdy.ai/api/search-image?query=cinematic%20photography%20of%20breaking%20news%20scene%2C%20dramatic%20lighting%2C%20retro%20newspaper%20texture%2C%20film%20grain%2C%20mysterious%20atmosphere%2C%20warm%20sepia%20tones%2C%20journalism%20vibe%2C%20dark%20moody%20background&width=900&height=400&seq=cta-banner-01&orientation=landscape"
            alt="订阅吃瓜每日榜单"
            className="w-full h-48 md:h-64 object-cover"
          />
        </div>

        <p className="text-3xl md:text-4xl font-heading font-bold text-primary-900 leading-relaxed mb-2">
          不想错过任何一个<span className="italic text-foreground-400 font-normal">大瓜</span>？
        </p>
        <p className="text-3xl md:text-4xl font-heading font-bold text-primary-900 leading-relaxed mb-2">
          订阅每日榜单，<span className="text-accent-500">新鲜热瓜</span>直送邮箱
        </p>
        <p className="text-sm text-foreground-500 mt-2 mb-8 md:mb-10">
          每日精选榜单 + 独家深度爆料，第一时间送达
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            className="form-website-alt"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="w-full sm:flex-1 px-5 py-3 rounded-full border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-accent-400 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full sm:w-auto px-7 py-3 rounded-full bg-primary-900 text-background-50 text-sm font-semibold hover:bg-primary-800 transition-colors disabled:opacity-60 whitespace-nowrap"
          >
            {status === 'loading' ? '订阅中...' : '立即订阅'}
          </button>
        </form>

        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-secondary-600' : 'text-accent-500'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}